/**
 * Public validation limits.
 *
 * These are shared so that a frontend form and its backend DTO cannot drift
 * apart. The backend remains the authority: every limit here is re-enforced
 * server-side and nothing here may be treated as a security control.
 */

export const EMAIL_MAX_LENGTH = 254;

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;

export const NAME_MIN_LENGTH = 2;
export const NAME_MAX_LENGTH = 100;

/** Nigerian NUBAN account numbers are exactly ten digits. */
export const BANK_ACCOUNT_NUMBER_LENGTH = 10;

/** Free-text reason attached to audited or maker-checker actions. */
export const REASON_MAX_LENGTH = 500;

/** Largest JSON request body the API accepts, expressed for `body-parser`. */
export const MAX_JSON_BODY_SIZE = '256kb';

/** Largest URL-encoded request body the API accepts. */
export const MAX_URLENCODED_BODY_SIZE = '256kb';

/** Header carrying the correlation identifier for a request. */
export const REQUEST_ID_HEADER = 'x-request-id';
